import { render, staticRenderFns } from "./ChooseExpertProfessionalTitle.vue?vue&type=template&id=6d472376&scoped=true"
import script from "./ChooseExpertProfessionalTitle.vue?vue&type=script&lang=js"
export * from "./ChooseExpertProfessionalTitle.vue?vue&type=script&lang=js"
import style0 from "./ChooseExpertProfessionalTitle.vue?vue&type=style&index=0&id=6d472376&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d472376",
  null
  
)

export default component.exports